import React, { Fragment, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import Axios from 'functions/Axios';
import { UPDATE_FOLDER_COLOR } from '../DAM_API/urls';
import { toast } from 'react-toastify';
import { useDownloadAssets } from '../../../context/DownloadAssetsContext';
import { useGlobalDropzone } from 'context/Dam/GlobalDropzoneContext';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';

const FolderGridSecondVersion = ({
  Data,
  EllipseActions,
  Title = 'Folder 1',
  Index = 0,
  isSelected,
  HandleSelect,
  isFolder = false,
  isEllipse = true,
  onUpload,
  selectedfolderid,
  fromBrandAssets,
  trash,
}) => {
  const lastKeyPressTime = useRef(0);
  const lastKey = useRef(null);
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState();
  const [selectedColor, setSelectedColor] = useState(false);
  const { UploadFiles } = useDownloadAssets();
  const { ignoreNextDrop, setIsDragging } = useGlobalDropzone();
  const location = useLocation();

  const path = location.pathname.split('/').pop()

  const hasDAMFullAccess = useHasAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]);

  // Editors may only upload into folders they created themselves; full access can
  // upload anywhere. Same ownership rule the folder's ellipse actions already use.
  const canUploadHere = Boolean(Data?.isSelf || hasDAMFullAccess);

  const { getRootProps, isDragActive } = useDropzone({
    noClick: true,
    noKeyboard: true,
    multiple: true,

    onDrop: (acceptedFiles) => {
      // Claim the drop either way, so a rejected one does not fall through to the
      // global dropzone and land in whichever folder is currently open.
      ignoreNextDrop.current = true;

      setIsDragging(false);
      if(path === "bin"){
         return ;
      }
      if (!canUploadHere) {
        toast.error('You can only upload to folders you created.');
        return;
      }
      uploadFiles(acceptedFiles);
      if (onUpload) {
        onUpload(acceptedFiles, Data);
      }
    },
    onDragOver: () => setIsDragging(false),
    onDragLeave: () => setIsDragging(true),
  });

  // Only light up the drop target for folders that will actually accept the files.
  const showDropTarget = isDragActive && canUploadHere;

  const uploadFiles = async (acceptedFiles) => {
    try {
      let data = new FormData();
      acceptedFiles.forEach((f) => {
        data.append('files', f);
        data.append('isVideo', f.type.includes('video'));
        data.append('isStreamable', f.type.includes('video'));
        // if (f.path?.includes('/')) {
        //   data.append('relativePaths', f.path.replace(/^\//, ''));
        // } else {
        //   data.append('relativePaths', '');
        // }

        if (f.path?.includes('/')) {
          const cleanPath = f.path.replace(/^(\.\/|\/)/, '');
          if (cleanPath.includes('/')) {
            data.append('relativePaths', cleanPath);
          }
        } else {
          data.append('relativePaths', '');
        }
      });
      data.append('folderId', Data?.id);
      const res = await UploadFiles(data, acceptedFiles.length);
      // toast.success(res?.data?.message);
    } catch (err) {
      console.error(err);
    }
  };
  const handleMouseClick = (e) => {
    if (selectedfolderid) {
      HandleSelect?.({ Image: Data, Key: 4 });
    }
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      HandleSelect?.({ Image: Data, Key: 1 });
    }
    if (e.shiftKey && e.button === 0) {
      HandleSelect?.({ Image: Data, Key: 3 });
    }
    if (e.ctrlKey && !e.shiftKey) {
      HandleSelect?.({ Image: Data, Key: 2 });
    }
  };

  const handleDoubleClick = () => {
    if (trash) {
      return;
    }
    if (isFolder) {
      HandleSelect?.({ Image: Data, Key: 4 });
    } else {
      navigate('/dam/dam-asset-information_v2', { state: { props: Data?.damFileId } });
    }
  };

  const handleKeyDown = (e) => {
    const now = Date.now();
    if (lastKey.current === e.key && now - lastKeyPressTime.current < 400) {
    }
    lastKey.current = e.key;
    lastKeyPressTime.current = now;
  };

  const handleSaveColor = async () => {
    try {
      const result = await Axios.put(UPDATE_FOLDER_COLOR, {
        color: selectedColor?.hex,
        folderId: Data?.id,
      });
      toast.success(result?.data?.message);
      setActiveId(null);
      setSelectedColor();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Fragment>
      <div
        {...getRootProps()} // drop enabled here
        // onDragEnter={() => setIsDragging(false)}

        tabIndex={Index}
        className={`dam_common_hover ${isSelected && 'dam_selected_design'}  _dam_folder_common_container_toggle ${
          showDropTarget ? 'dam_drag_active' : ''
        }`}
        style={{
          position: 'relative',
          ...(showDropTarget && {
            border: '1px dashed #753cb7',
          }),

          borderRadius: '8px',
        }}
        onClick={handleMouseClick}
        onDoubleClick={handleDoubleClick}
        onKeyDown={handleKeyDown}
      >
        <div className=" d-flex justify-content-between">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <mask
                    id="mask0_7795_12750"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_7795_12750)">
                    <path
                      d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.175C9.44167 4 9.69583 4.05 9.9375 4.15C10.1792 4.25 10.3917 4.39167 10.575 4.575L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                      fill={Data?.color ?? '#757575'}
                      {...(Data?.color === '#FFFFFF'
                        ? {
                            stroke: '#757575', // border color
                            strokeWidth: 0.2, // adjust thickness
                          }
                        : {})}
                    />
                  </g>
                </svg>
              </div>

              <div className="_dam_folder_common_title d-flex">{Title}</div>
            </div>
          </div>
          {isEllipse && (
            <div
              onClick={(e) => e.stopPropagation()}
              onDoubleClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              {typeof EllipseActions === 'function' ? EllipseActions(Data) : EllipseActions}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default FolderGridSecondVersion;
